import { Link } from 'react-router-dom';
import { navItems } from '@/mocks/navData';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-gift-2-line text-lg"></i>
                </span>
                <span className="text-xl font-heading font-bold text-background-50">
                  福利导航
                </span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                一站式福利资源聚合平台，汇聚折扣优惠、会员权益、生活补贴、职场福利等海量信息，帮助您轻松享受更多实惠与权益。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <ul className="flex flex-col gap-2">
                {navItems.slice(1, 5).map((item) => (
                  <li key={item.href}>
                    <Link
                      to={item.href}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                福利分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                关于我们
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    联系我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#newsletter"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    新闻通讯
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2026 福利导航. 本站所有信息仅供参考，具体以官方发布为准。
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="text-xs text-background-400 hover:text-primary-400 transition-colors"
                rel="nofollow"
              >
                隐私政策
              </a>
              <a
                href="#"
                className="text-xs text-background-400 hover:text-primary-400 transition-colors"
                rel="nofollow"
              >
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}